import React from 'react'
// import shallowEqual from 'fbjs/lib/shallowEqual'
import shallowCompare from 'react-addons-shallow-compare'
import R from 'ramda'

import * as selectors from './selectors'
import * as actions from './actions'
const defaultGridTools = { ...selectors, ...actions }

const empty = {}

const extractPosition = evt => ({
  rowIndex: parseInt(evt.target.getAttribute('data-rowIndex')),
  columnIndex: parseInt(evt.target.getAttribute('data-columnIndex')),
})

const createCell = (Cell, mapStateToCellProps, gridTools) => {
  const tools = gridTools || defaultGridTools

  const {
    getCellData,
    isCellSelected,
    isSelectingCells,
    selectionStarts,
    selectionEnds,
    selectionExpands,
    isCellEditing,
    getEditContent,
    getHeaders,
    getEditPosition,
    setEditContent,
    commitEdit,
    startEdit,
    getDataAtRow,
    isCellEditable,
    getEditInitKey,
    getSelectedBounds,
    setSelection,
  } = tools

  const extractLocalState = (
    { columnIndex, rowIndex, gridDataStore },
    mapStateToCellProps
  ) => {
    const gridState = gridDataStore.getState()

    const customizedData = mapStateToCellProps
      ? mapStateToCellProps(rowIndex, columnIndex, gridState)
      : empty

    const editing = isCellEditing(rowIndex, columnIndex, gridState)
    return {
      cellData:
        customizedData === empty &&
        getCellData(rowIndex, columnIndex, gridState),
      selected: isCellSelected(rowIndex, columnIndex, gridState),
      ...customizedData,
      editing,
      editContent: editing ? getEditContent(gridState) : undefined,
      editInitKey: editing ? getEditInitKey(gridState) : undefined,
    }
  }

  class CellWrapper extends React.Component {
    constructor(props) {
      super(props)
      this.state = extractLocalState(this.props, mapStateToCellProps)
      this.mouseDown = this.mouseDown.bind(this)
      this.mouseUp = this.mouseUp.bind(this)
      this.mouseMove = this.mouseMove.bind(this)
      this._mouseClick = this._mouseClick.bind(this)
      this._edit = this._edit.bind(this)
      this._commit = this._commit.bind(this)
    }

    mouseDown(evt) {
      if (evt.buttons === 1) {
        const {
          gridDataStore: { dispatch },
        } = this.props
        const position = extractPosition(evt)
        dispatch(selectionStarts(position))
      }
      // rigth click
      if (evt.buttons === 2) {
        const { rowIndex, columnIndex } = extractPosition(evt)
        const {
          gridDataStore: { dispatch, getState },
        } = this.props
        const selectionBounds = getSelectedBounds(getState())
        if (R.isNil(selectionBounds) || R.isEmpty(selectionBounds)) {
          dispatch(
            setSelection({
              x1: columnIndex,
              x2: columnIndex,
              y1: rowIndex,
              y2: rowIndex,
            })
          )
        } else {
          const { x1, y1, x2, y2 } = selectionBounds
          if (
            rowIndex < y1 ||
            rowIndex > y2 ||
            columnIndex < x1 ||
            columnIndex > x2
          ) {
            dispatch(
              setSelection({
                x1: columnIndex,
                x2: columnIndex,
                y1: rowIndex,
                y2: rowIndex,
              })
            )
          }
        }
      }
    }

    mouseUp(evt) {
      // TODO return when not selecting!!!!!!....
      const {
        gridDataStore: { dispatch, getState },
      } = this.props
      if (isSelectingCells(getState())) {
        const position = extractPosition(evt)
        dispatch(selectionEnds(position))
      }
    }

    mouseMove(evt) {
      const {
        gridDataStore: { dispatch, getState },
      } = this.props
      if (isSelectingCells(getState())) {
        const position = extractPosition(evt)
        dispatch(selectionExpands(position))
      }
    }

    _mouseClick() {
      // if (evt.detail > 1) {
      const { columnIndex, rowIndex } = this.props
      const { gridDataStore: store } = this.props
      store.dispatch(
        startEdit({
          columnIndex,
          rowIndex,
          content: getCellData(rowIndex, columnIndex, store.getState()),
          isCellEditable,
        })
      )
      // }
    }

    _edit(val) {
      this.props.gridDataStore.dispatch(setEditContent(val))
    }

    _commit() {
      if (this.state.editing) {
        const { gridDataStore: store } = this.props
        const pos = getEditPosition(store.getState())
        const content = getEditContent(store.getState())
        const headers = getHeaders(store.getState())
        const rowData = getDataAtRow(pos.rowIndex, store.getState())
        const editInfo = { ...pos, content, headers, rowData }
        store.dispatch(commitEdit(editInfo))
      }
    }

    componentDidMount() {
      const { gridDataStore } = this.props
      if (gridDataStore)
        this.unlinkStore = gridDataStore.subscribe(() => {
          if (this.mounted) {
            this.setState(extractLocalState(this.props, mapStateToCellProps))
          }
        })
      this.mounted = true
    }

    componentWillUnmount() {
      if (this.unlinkStore) this.unlinkStore()
      this.mounted = false
    }

    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState)
    }

    render() {
      const { columnIndex, rowIndex, style } = this.props
      const { cellData, ...rest } = this.state

      return (
        <Cell
          {...{
            rowIndex,
            columnIndex,
            style,
            'data-columnIndex': columnIndex,
            'data-rowIndex': rowIndex,
            onMouseDown: this.mouseDown,
            onMouseUp: this.mouseUp,
            onMouseMove: this.mouseMove,
            onDoubleClick: this._mouseClick,
            onEdit: this._edit,
            commitEdit: this._commit,
          }}
          {...rest}
        >
          {cellData}
        </Cell>
      )
    }
  }
  return CellWrapper
}
// export default DataCell
export default ({
  gridDataStore,
  mapStateToCellProps,
  cellComp,
  gridTools,
}) => {
  const CellComponent = createCell(cellComp, mapStateToCellProps, gridTools)
  return props => <CellComponent {...props} gridDataStore={gridDataStore} />
}
